module.exports = __webpack_public_path__ + "static/media/furia-ability.e914616e.svg";